import { type FC } from 'react'
import { AlertIcon } from '../AlertIcon/AlertIcon'
import { BookingStatus } from '../../models/Scheduling'
import { selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useGetBookingsQuery } from '../../store/scheduling/scheduling'
import { hasSchedulingAlert } from './hasSchedulingAlert'

const ALERT_POLLING_INTERVAL = 30000
const ALERT_PAGE_REQUEST = { page: 0, size: 1 }
const ALERT_QUERY_OPTIONS = { refetchOnMountOrArgChange: true, pollingInterval: ALERT_POLLING_INTERVAL, skipPollingIfUnfocused: true }

export const SchedulingMenuIcon: FC = () => {
  const authenticatedUser = useAppSelector(selectSafeAuthenticatedUser)
  const alertArgs = { accountId: authenticatedUser.accountId, userIds: [authenticatedUser.id], pageRequest: ALERT_PAGE_REQUEST }
  const { data: requests } = useGetBookingsQuery({ ...alertArgs, status: BookingStatus.REQUESTED }, ALERT_QUERY_OPTIONS)
  const { data: suggestions } = useGetBookingsQuery({ ...alertArgs, status: BookingStatus.OPPORTUNITY }, ALERT_QUERY_OPTIONS)
  const hasAlert = hasSchedulingAlert(requests?.page.totalElements ?? 0, suggestions?.page.totalElements ?? 0)

  return (
    <AlertIcon size={1.8} active={hasAlert}>
      <i className='bi bi-calendar' />
    </AlertIcon>
  )
}
